// Assigned Dependencies
module.exports = (function() {
	window.lcb.constant.addCourseApiErrors = { INVALIDAPPLICATIONTYPE:7439,DUPLICATEDCOURSE:7440,DUPLICATEDPROGRAM:7440,INVALIDCAMPUS:7441,INVALIDQUANTITY:13356, ACTIVETRANSACTION:13805 };
	window.lcb.constant.updateCourseApiErrors = {quantity:{OUT_OF_RANGE:9010, TRANSACTION_FOUND:13805}}
})();